import TransactionStatus from "../../entities/TransactionStatus";

export enum ArticleTransactionEntityType {
    WAREHOUSE = "Almacén",
    DELIVERY_PERSON = "Repartidor",
    UNKNOWN = "UNKNOWN",
}

class ArticleTransactionResponse {
    public id: string;
    public amount: number;
    public direction: string;
    public error?: string;
    public status: TransactionStatus;
    public articleId: string;
    public articleName: string;
    public createdAt: number;
    public amountFromBefore?: number;
    public amountToBefore?: number;
    public comment?: string;
    public fromId?: string;
    public fromName?: string;
    public fromType?: ArticleTransactionEntityType;
    public toId: string;
    public toName?: string;
    public toType?: ArticleTransactionEntityType;

    constructor(
        id: string,
        amount: number,
        articleId: string,
        articleName: string,
        direction: string,
        status: TransactionStatus,
        createdAt: number,
        toId: string,
        toName?: string,
        toType?: ArticleTransactionEntityType,
        fromId?: string,
        fromName?: string,
        fromType?: ArticleTransactionEntityType,
        amountFromBefore?: number,
        amountToBefore?: number,
        comment?: string,
        error?: string
    ) {
        this.id = id;
        this.createdAt = createdAt;
        this.amount = amount;
        this.direction = direction;
        this.error = error;
        this.articleId = articleId;
        this.articleName = articleName;
        this.status = status;
        this.amountFromBefore = amountFromBefore;
        this.amountToBefore = amountToBefore;
        this.comment = comment;
        this.toId = toId;
        this.toName = toName;
        this.toType = toType;
        this.fromId = fromId;
        this.fromName = fromName;
        this.fromType = fromType;
    }

}

export default ArticleTransactionResponse;